export namespace ArpyVehicleFunctionsActions {
    export class SetAllArpyVehicleFunctions {
        static readonly type = '[ArpyVehicleFunctions] SetAllArpyVehicleFunctions';
        constructor() {}
    }
}
